import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Faded } from "baby-i-am-faded";
import cs from "classnames";
import clsx from "clsx";
import React from "react";
import { Modal } from "./Modal";
import { PageContainer } from "./PageContainer";
import { useDisclosure } from "../utils";
export var NavBar = function(_param) {
    var logo = _param.logo, _navs = _param.navs, navs = _navs === void 0 ? [] : _navs, _className = _param.className, className = _className === void 0 ? "" : _className, style = _param.style, rest = _object_without_properties(_param, [
        "logo",
        "navs",
        "className",
        "style"
    ]);
    var ref = useDisclosure(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var menuButtonStyle = {
        width: 32,
        height: 32
    };
    return /*#__PURE__*/ _jsxs(PageContainer, _object_spread_props(_object_spread({
        dontContain: true
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("flex w-full py-4", className),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "self-start",
                        children: logo
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "hidden md:flex items-center space-x-6 lg:space-x-8 font-medium ",
                        children: Array.isArray(navs) ? navs.map(function(x, i) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "cursor-pointer",
                                children: x
                            }, i);
                        }) : navs
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "appearance-none block md:hidden",
                        onClick: onOpen,
                        children: /*#__PURE__*/ _jsx(Menu, {
                            style: _object_spread({}, menuButtonStyle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Modal, {
                isOpen: isOpen,
                onClose: onClose,
                content: /*#__PURE__*/ _jsxs(Faded, {
                    className: cs("bg-gray-900/80 fixed w-screen h-screen inset-0", "pt-6 space-y-6 flex flex-col items-center text-white", "font-medium"),
                    children: [
                        /*#__PURE__*/ _jsx(Modal.CloseButton, {
                            // style={{ right: 20, top: 20, ...menuButtonStyle }}
                            onClick: onClose
                        }),
                        Array.isArray(navs) ? /*#__PURE__*/ _jsx(_Fragment, {
                            children: navs.map(function(x, i) {
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "",
                                    children: x
                                }, i);
                            })
                        }) : navs
                    ]
                })
            })
        ]
    }));
};
var Menu = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                y1: "12",
                x2: "21",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                y1: "18",
                x2: "21",
                y2: "18"
            })
        ]
    }));
};
